import React from 'react'
import { BAR_H, MILESTONE_SIZE, ROW_H } from '../../lib/constants'

export interface GhostMarkerProps {
  x: number
  width: number
  rowTop: number
  label: string
  isMilestone: boolean
  onClick?: (e: React.MouseEvent) => void
  onPointerEnter?: (e: React.PointerEvent) => void
  onPointerLeave?: () => void
}

/** Hollow, dashed placeholder for a cross-schedule (external) endpoint. Spec B §8.6. */
const GhostMarker: React.FC<GhostMarkerProps> = ({ x, width, rowTop, label, isMilestone, onClick, onPointerEnter, onPointerLeave }) => {
  const cy = rowTop + ROW_H / 2
  if (isMilestone) {
    const h = MILESTONE_SIZE / 2
    const points = `${x},${cy - h} ${x + h},${cy} ${x},${cy + h} ${x - h},${cy}`
    return (
      <g data-ghost onClick={onClick} onPointerEnter={onPointerEnter} onPointerLeave={onPointerLeave} className="cursor-pointer">
        {/* BUG-SCH-UI2-01 fix: a real (if invisible) fill makes the whole interior hit-testable —
            `fill-none` leaves only the dashed stroke hit-testable, and a real pointer missed even
            that (the row's selection-highlight rect painted earlier in the SVG takes the hit
            instead once this shape reports no hit of its own at that pixel). */}
        <polygon points={points} className="fill-transparent stroke-muted-foreground" strokeDasharray="3 3" />
        <text x={x + h + 6} y={cy} dominantBaseline="middle" className="text-xs italic fill-muted-foreground pointer-events-none select-none">{label}</text>
      </g>
    )
  }
  const w = Math.max(2, width)
  const y = cy - BAR_H / 2
  return (
    <g data-ghost onClick={onClick} onPointerEnter={onPointerEnter} onPointerLeave={onPointerLeave} className="cursor-pointer">
      {/* BUG-SCH-UI2-01 fix: see the milestone variant's comment above. */}
      <rect x={x} y={y} width={w} height={BAR_H} rx={3} className="fill-transparent stroke-muted-foreground" strokeDasharray="3 3" />
      <text x={x + w + 6} y={cy} dominantBaseline="middle" className="text-xs italic fill-muted-foreground pointer-events-none select-none">{label}</text>
    </g>
  )
}

export default GhostMarker
